/*
 * creations-gallery.js
 * Mobile auto-scroll marquee for sections/creations-gallery.liquid — same continuous,
 * seamless feel as the German launch gallery (sections/de-launch-splash.liquid). Desktop
 * keeps the static featured grid (handled entirely in CSS).
 *
 * Why JS: the cards render via {% content_for 'blocks' %}, so they can't be duplicated in
 * Liquid the way the German section's images are. We clone the cards once here; the clones
 * are hidden on desktop via CSS and make the CSS -50% marquee loop seamless on mobile.
 *
 * Progressive enhancement: with JS off (or reduced-motion on) the section falls back to the
 * manual horizontal scroll defined in the section CSS. Loop duration is set in Liquid
 * (card count × speed) on the track's --creations-marquee-duration var.
 */
(function () {
  'use strict';

  // Respect reduced-motion: leave the manual-scroll fallback in place, don't auto-move.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  function setup(track) {
    if (track.dataset.creationsMarqueeReady) return;
    var cards = Array.prototype.slice.call(track.children);
    if (cards.length < 2) return; // nothing to loop
    track.dataset.creationsMarqueeReady = '1';

    var frag = document.createDocumentFragment();
    cards.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-creations-clone', '');
      clone.removeAttribute('id');
      // Keep clones out of the tab order — they're decorative duplicates.
      clone.querySelectorAll('a, button, [tabindex]').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
      frag.appendChild(clone);
    });
    track.appendChild(frag);

    var viewport = track.closest('[data-creations-viewport]') || track.parentElement;
    if (viewport) viewport.classList.add('is-marquee');
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-creations-track]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // Re-init when a merchant edits the section in the Theme Editor (fresh DOM).
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
